import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';

const About = () => {
  const { darkMode } = useContext(ThemeContext);

  return (
    <div className={`flex-1 flex flex-col ${darkMode ? 'dark' : ''} bg-white dark:bg-gray-900`}>
      <div className="flex-grow">

        {/* Header */}
        <div className="text-center pt-16 pb-10 px-4">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 dark:text-white tracking-tight mb-4">
            Built by car people, <span className="text-gray-400 dark:text-gray-500">for car people.</span>
          </h1>
          <p className="text-lg text-gray-500 dark:text-gray-400 max-w-2xl mx-auto">
            Learn about the team behind Stonewall Invoicing and our mission to make automotive business management simple and affordable.
          </p>
        </div>

        <div className="max-w-5xl mx-auto px-4 pb-20">

          {/* Image */}
          <div className="mb-8">
            <img
              src="/Stonewall_office.png"
              alt="Stonewall Office"
              className="rounded-lg shadow-md w-full object-cover h-[18rem] md:h-[22rem]"
              style={{ objectPosition: 'center 50%' }}
            />
          </div>

          {/* Our Story */}
          <div className="bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-md rounded-lg p-6 mb-6">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Our Story</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              Founded in 2023, Stonewall Invoicing started when we saw our local shops struggling with overly complicated, overpriced invoicing software. As car enthusiasts and software engineers, we knew we could build something better — a streamlined, no-nonsense program that lets mechanics focus on their work instead of fighting their software.
            </p>
            <p className="text-gray-600 dark:text-gray-300">
              Today, over 100 automotive businesses across the country use Stonewall Invoicing to create professional invoices, manage customers, and look up vehicle specs — all from one app.
            </p>
          </div>

          {/* Mission */}
          <div className="bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-md rounded-lg p-6 mb-6">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Our Mission</h2>
            <p className="text-gray-600 dark:text-gray-300">
              Affordable, straightforward invoicing software that just works. No bloat, no unnecessary complexity — just the tools you need to run your shop and get back to what you do best: working on cars.
            </p>
          </div>

          {/* Values — simple inline list */}
          <div className="bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-md rounded-lg p-6">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">What We Stand For</h2>
            <ul className="space-y-3 text-gray-600 dark:text-gray-300">
              <li className="flex items-start">
                <svg className="w-5 h-5 text-blue-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <span><strong className="text-gray-900 dark:text-white">Simplicity</strong> — Powerful software doesn't have to be complicated to use.</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-blue-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <span><strong className="text-gray-900 dark:text-white">Affordability</strong> — Professional tools at a price that makes sense for small shops.</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-blue-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <span><strong className="text-gray-900 dark:text-white">Reliability</strong> — Software you can depend on, every day, without fail.</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-blue-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <span><strong className="text-gray-900 dark:text-white">Integrity</strong> — Honest and transparent in everything we do.</span>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default About;
